import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
import modaalCss from 'modaal/dist/css/modaal.css';
import modaal from 'modaal';

import slick from "slick-carousel/slick/slick.min.js";
import slickCss from "slick-carousel/slick/slick.css";
import slickTheme from "slick-carousel/slick/slick-theme.css";


import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"
import ScrollReveal from "scrollreveal"


class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();


    function buildFormat() {
      var $toc = $('<div />', {id: 'toc_container'});
      var $list = $('<ul />', {class: 'toc_list'});
      var $groups = $('.u-format-group');
      // フォーマットグループごとの処理
      for (var i = 0; i < $groups.length; i++) {
        var $_list = $('<ul />');
        var $group = $($groups[i]);
        var group_title = $group.find('.u-format-group__title').text();
        var $group_li = $('<li />');
        var groupid = 'formatgroup_' + (i + 1);
        $group.attr('id', groupid);
        $list.append(
          $group_li.append(
            $('<a />',
              {
                text: (i + 1) + '. ' + group_title,
                href: '#' + groupid
              }
            )
          )
        );
        // フォーマットごとの処理
        var $formats = $group.find('.u-format-group__content').find('.u-format');
        var $_ul = $('<ul />');
        for (var m = 0; m < $formats.length; m++) {
          var $format = $($formats[m]);
          var $format_title = $format.find('.u-format__title');
          var $format_content = $format.find('.u-format__content');
          var formatid = 'format_' + (i + 1) + (m + 1);
          $format.find('.u-format__title').attr('id', formatid);
          var format_title = $format_title.text();
          var format_number = (i + 1) + '.' + (m + 1) + '. ';
          $format_title.text(format_number + format_title);
          $_ul.append(
            $('<li />').append(
              $('<a />', {
                  href: '#' + formatid,
                  text: format_number + format_title
                }
              )
            )
          );

          // コードを追加
          var $code = $('<div />', {class: 'u-format__code'});
          $code.append($('<div />', {
            class: 'u-format__code__title',
            text: format_number + format_title
          }));
          var formathtml = $format.find('.u-format__content').html();
          $code.append($('<pre />', {text: formathtml.trim()}));
          $format.append($code);
        }
        $group_li.append($_ul);
        $_list.append($group_li);
        $list.append($_list);
      }
      $toc.append($list);
      $('.c-breadcrumb').after(
        $('<div />', {
            class: 'l-container'
          }
        ).append($toc)
      );
    }

    $(function () {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }

      const breakpoint = 750;

      owls.imagesLoaded(function () {
        //top
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: true,
          dotsSpeed: 800,
          navSpeed: 800,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 2000,
          center: true,
          navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
          responsive: {
            0: {
              items: 1,
              nav: false
            },
            950: {
              nav: true
            }
          }
        });

        //real-estate
        $('.c-real-estate-slider__slider').owlCarousel({
          items: 4,
          margin: 8,
          dots: false,
          loop: true,
          //nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 400,
          center: true,
          //navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>','<i class="fa fa-angle-right" aria-hidden="true"></i>'],
          responsive: {
            0: {
              items: 3
            },
            950: {
              margin: 8
            }
          }
        });

        //->カード_カルーセル
        let minPostsCount = 4;
        if ($(window).innerWidth() <= breakpoint) {
          minPostsCount = 2;
        }

        $('.js-card-slider').each(function (index, element) {
          const length = $(element).find('.c-card-post__block').length;

          if (length < minPostsCount) {
            $(element).removeClass('owl-carousel js-card-slider').addClass('is-flexbox');
            return true;
          }

          const options = {
            margin: 37
          }

          $(element).owlCarousel({
            margin: options.margin,
            dots: true,
            loop: true,
            nav: true,
            autoplayHoverPause: true,
            autoplay: true,
            autoplaySpeed: 500,
            autoWidth: false,
            autoHeight: false,
            center: false,
            navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
            responsive: {
              // breakpoint from 0 up
              0: {
                items: 1,
              },
              // breakpoint from 750 up
              750: {
                items: 3.3,
              }
            }
          });
        });
      });
      //buildFormat();
    });
  }
}

window.GApp = new App();

(function ($) {

  function modaal() {
    $(".js-imagemodal").modaal({
      type: 'image'
    });
    $(".c-composite-search__block").modaal({
      content_source: '#inline'
    });
    $(".l-footer__menulist li.is-modal").modaal({
      content_source: '#inline'
    });
  }

  function searchModal() {
    $('.c-composite-search__block').on('click', function () {
      const dataValue = $(this).data("search-target");

      if (!dataValue) {
        return false;
      }

      $('.c-search-modal__content').hide();
      $('.c-search-modal__title').removeClass('is-open');

      const $modalBlock = $('.c-search-modal__block[data-search-name="' + dataValue + '"]');

      if ($modalBlock) {
        $modalBlock.find('.c-search-modal__title').addClass('is-open');
        $modalBlock.find('.c-search-modal__content').slideDown(200);
      }

    });
    // $('.c-composite-search__block[data-search-target="price"]').on('click', function () {
    //   $('.c-search-modal__content').hide();
    //   $('.c-search-modal__title').removeClass('is-open');
    //   $('.c-search-modal__title.is-price').addClass('is-open');
    //   $('.c-search-modal__title.is-price').next('.c-search-modal__content').slideDown(200);
    // });
    // $('.c-composite-search__block[data-search-target="yield"]').on('click', function () {
    //   $('.c-search-modal__content').hide();
    //   $('.c-search-modal__title').removeClass('is-open');
    //   $('.c-search-modal__title.is-yield').addClass('is-open');
    //   $('.c-search-modal__title.is-yield').next('.c-search-modal__content').slideDown(200);
    // });
    // $('.c-composite-search__block[data-search-target="width"]').on('click', function () {
    //   $('.c-search-modal__content').hide();
    //   $('.c-search-modal__title').removeClass('is-open');
    //   $('.c-search-modal__title.is-width').addClass('is-open');
    //   $('.c-search-modal__title.is-width').next('.c-search-modal__content').slideDown(200);
    // });

    $('.c-search-modal__title').on('click', function () {
      $(this).toggleClass('is-open');
      $(this).next(".c-search-modal__content").slideToggle(200);
    });
  }


  var growApp = function () {
  };

  var growApp2 = {
    // お部屋
    slick: function () {
      const breakpoint = 750;
      const slidesToShowPC = 7;
      const slidesToShowSP = 5;

      $('.js-slider-main').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: '.js-thumb',
        dots: true,
        infinite: true,
        appendDots: '.c-tab-slider__dots'
      });
      $('.js-thumb').slick({
        slidesToShow: slidesToShowPC,
        slidesToScroll: 1,
        asNavFor: '.js-slider-main',
        centerMode: true,
        focusOnSelect: true,
        centerPadding: 0,
        infinite: true,
        responsive: [
          {
            breakpoint: breakpoint,
            settings: {
              slidesToShow: slidesToShowSP,
              slidesToScroll: 1,
            }
          },
        ]
      });

      function addCenterClass() {
        if ($(window).innerWidth() <= breakpoint && $('.js-thumb .js-thumb-item').length < slidesToShowSP + 1) {
          $('.js-thumb').addClass("is-center");
          $('.js-thumb').slick('slickSetOption', 'centerMode', false, true);
          $('.js-thumb').slick('slickSetOption', 'focusOnSelect', false, true);
        } else {
          if ($('.js-thumb .js-thumb-item').length < slidesToShowPC + 1) {
            $('.js-thumb').addClass("is-center");
            $('.js-thumb').slick('slickSetOption', 'centerMode', false, true);
            $('.js-thumb').slick('slickSetOption', 'focusOnSelect', true, false);
          }
        }
      }

      addCenterClass();

      $('.c-tabs__navs.js-tabs-nav li:nth-child(1)').on('click', function () {
        $('.js-slider-main').slick("refresh");
        $('.js-thumb').slick("refresh");
        addCenterClass();
      });

      // サムネイルの'slidesToShow'より少ない場合の処理
      $('.js-slider-main').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        addCenterClass();
      });
    },

    // 外観・共用部
    slick2: function () {
      const breakpoint = 750;
      const slidesToShowPC = 7;
      const slidesToShowSP = 5;

      $('.js-slider-main2').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: '.js-thumb2',
        dots: true,
        infinite: true,
        appendDots: '.c-tab-slider__dots2'
      });

      $('.js-thumb2').slick({
        slidesToShow: slidesToShowPC,
        slidesToScroll: 1,
        asNavFor: '.js-slider-main2',
        centerMode: true,
        focusOnSelect: true,
        centerPadding: 0,
        infinite: true,
        responsive: [
          {
            breakpoint: breakpoint,
            settings: {
              slidesToShow: slidesToShowSP,
            }
          },
        ]
      });

      function addCenterClass() {
        if ($(window).innerWidth() <= breakpoint && $('.js-thumb2 .js-thumb-item').length < slidesToShowSP + 1) {
          $('.js-thumb2').addClass("is-center");
          $('.js-thumb2').slick('slickSetOption', 'centerMode', false, true);
          $('.js-thumb2').slick('slickSetOption', 'focusOnSelect', false, true);
        } else {
          if ($('.js-thumb2 .js-thumb-item').length < slidesToShowPC + 1) {
            $('.js-thumb2').addClass("is-center");
            $('.js-thumb2').slick('slickSetOption', 'centerMode', false, true);
            $('.js-thumb2').slick('slickSetOption', 'focusOnSelect', true, false);
          }
        }
      }

      addCenterClass();

      // サムネイルの'slidesToShow'より少ない場合の処理
      $('.js-slider-main2').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        addCenterClass();
      });

      $('.c-tabs__navs.js-tabs-nav li:nth-child(2)').on('click', function () {
        $('.js-slider-main2').slick("refresh");
        $('.js-thumb2').slick("refresh");

        addCenterClass();
      });
    }
  };
  /*
   * userAgent取得
   * */
  var Agent = window.navigator.userAgent.toLowerCase();
  var _ua = (function (u) {
    return {
      Tablet: (u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1)
        || u.indexOf("ipad") != -1
        || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
        || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
        || u.indexOf("kindle") != -1
        || u.indexOf("silk") != -1
        || u.indexOf("playbook") != -1,
      Mobile: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
        || u.indexOf("iphone") != -1
        || u.indexOf("ipod") != -1
        || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
        || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
        || u.indexOf("blackberry") != -1
    }
  })(Agent);


  //ボタンをspanでラップする
  growApp.prototype.buttonWrap = function () {
    var button = $(".c-button");
    button.wrapInner("<span></span>");
  }

  //ボタン athome
  growApp.prototype.buttonAthome = function () {
    var button = $(".c-button.is-athome");
    var buttonImg = button.find("img");
    button.hover(
      function () {
        buttonImg.attr("src", "/assets/images/logo-atmome-hover.png");
      }
      , function () {
        buttonImg.attr("src", "/assets/images/logo-atmome.png");
      }
    );
  }


  //スクロールリーバル
  growApp.prototype.scrollReveal = function () {
    window.sr = ScrollReveal({duration: 600, mobile: false});

    function domEach(items, callback) {
      if (typeof items === "string") {
        var items = $(items);
      }
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        // callback = callback.bind(item)
        callback(i, item);
      }
    }

    //common
    sr.reveal(".js-fadein-bootom", {delay: 300, scale: 1, duration: 2000, origin: 'bottom', distance: '10px'}, 100);
    //mainVisual
    sr.reveal(".c-main-visual", {scale: 1, duration: 2000, origin: 'bottom', distance: '10px'}, 100);
    sr.reveal(".c-main-visual__image", {delay: 600, scale: 1, duration: 2000, origin: 'bottom', distance: '10px'}, 100);
    sr.reveal(".c-main-visual__title,.c-main-visual__subtitle", {
      delay: 800,
      scale: 1,
      duration: 2000,
      origin: 'bottom',
      distance: '10px'
    }, 100);
    //toppage
    sr.reveal(".c-concept__bgimage.is-left", {
      delay: 300,
      scale: 1,
      duration: 2000,
      origin: 'bottom',
      distance: '30px'
    }, 100);
    sr.reveal(".c-concept__bgimage.is-right", {
      delay: 600,
      scale: 1,
      duration: 2000,
      origin: 'bottom',
      distance: '30px'
    }, 100);
    sr.reveal(".c-service__block", {delay: 200, scale: 1, duration: 2000, origin: 'bottom', distance: '30px'}, 100);
    //pageheader
    sr.reveal(".c-page-header__title", {scale: 1, duration: 2000, origin: 'bottom', distance: '10px'}, 100);
  }

  $(function () {
    var app = new growApp();
    app.buttonWrap();
    app.buttonAthome();
    app.scrollReveal();
    modaal();
    searchModal();

    growApp2.slick();
    $('.is-switch').one('click', function () {
      if ($('.c-tabs__content').hasClass('is-active')) {
        growApp2.slick2();
      }
    });
    if ($(".c-tab-slider").find("*[data-tab-target=1]").hasClass("is-active")) {
      growApp2.slick2();
    }
  });

})(jQuery);
